import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOpenToast]',
  standalone: false,
})
export class OpenToastDirective {
  @Input() idOpen: string;

  constructor() {}

  @HostListener('click') onClick() {
    this.openToast();
  }

  public openToast() {
    if (this.idOpen) {
      const elementHTML = document.getElementById(this.idOpen);
      elementHTML.focus();
    }
  }
}
